module.exports = __webpack_public_path__ + "img/img-5.73ff6604.svg";